export default __webpack_public_path__ + "static/remax-28268d5fddf02f5499232917231dbb41.png";